module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq412-9a07ecdf09f2e09c9a7e6f09e3c566ed.jpg";